import { RechartsRootState } from '../store';

export const pickAxisType = <T>(_state: RechartsRootState, axisType: T): T => axisType;
